var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolarPower01 = function SvgSolarPower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "solar-power-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#solar-power-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.805 7.711-.954 1.23 1.542-.211-.211 1.542 1.23-.954.588 1.441.588-1.441 1.23.954-.211-1.542 1.542.211-.954-1.23 1.44-.588-1.44-.588.954-1.23-1.542.211.21-1.542-1.23.954L12 3.488l-.588 1.44-1.23-.954.211 1.542-1.542-.21.954 1.23-1.441.587 1.441.588ZM12 5.55A1.574 1.574 0 1 1 12 8.696 1.574 1.574 0 0 1 12 5.55Zm-2.327 7.134H5.926v2.421h3.747v-2.421Zm.453 0h3.747v2.421h-3.747v-2.421Zm7.948 0h-3.747v2.421h3.747v-2.421Zm-12.148 2.83h3.747v2.42H5.926v-2.42Zm7.947 0h-3.747v2.42h3.747v-2.42Zm.454 0h3.747v2.42h-3.747v-2.42Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "solar-power-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSolarPower01 as ReactComponent };